interface IHomeDepotProXtraLogoProps {
    height?: number;
    width?: number;
}

const HomeDepotProXtraLogo: React.FunctionComponent<IHomeDepotProXtraLogoProps> = ({
    height,
    width,
}) => {
    return (
        <img
            alt="Home Depot Pro Xtra Logo"
            src="/images/Marketplace/homeDepotFg.svg"
            height={height ? `${height}px` : ""}
            width={width ? `${width}px` : ""}
        />
    );
};
export default HomeDepotProXtraLogo;
